/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useState } from "react";
import { Avatar, Dropdown, Badge, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/landingFeatures/qhrset.png";
import Notifications from "../../assets/notifications.svg";
import { UserOutlined, LogoutOutlined, FileOutlined } from "@ant-design/icons";

import "./qsetheader.scss";
import useStatsStore from "../../store/stats.store";
import useAuthStore from "../../store/auth.store";

const QSETHeader = ({ hideHeaderContent = false }) => {
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const { unreadNotifications, markNotificationAsRead } = useStatsStore();
  const { userLogout } = useAuthStore();
  const navigate = useNavigate();
  const qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));

  useEffect(() => {}, []);

  const handleLogOut = () => {
    userLogout();
    localStorage.removeItem("qsetUserDetails");
    navigate(`/home`);
  };

  const handleProfile = () => {
    navigate(`/profile`);
  };

  const items = [
    {
      label: (
        <div className="e-mail">
          {qsetUserData?.myapplication?.applicationid.email}
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div className="log-out" onClick={handleProfile}>
          FAQ
        </div>
      ),
      key: "1",
      icon: <FileOutlined />,
    },
    {
      label: (
        <div className="log-out" onClick={handleLogOut}>
          Logout
        </div>
      ),
      key: "2",
      icon: <LogoutOutlined />,
    },
  ];

  const handleOpenChange = (visible) => {
    setToolTipOpen(visible); // updates on hover
  };

  return (
    <nav className="qsetnavbar-wrapper">
      <div className="qsetlogo-wrapper">
        <img src={Logo} className="logo" alt="QuallyHire" />
      </div>
      <div className="qsetservices-links-wrapper">
        <Link className="links">HMW LLP</Link>
        <div className="subtitle">Candidate SKill Evaluations Platform</div>
      </div>
      {!hideHeaderContent && (
        <div className="info-wrapper_1">
          <Badge
            className="info-logo"
            count={unreadNotifications > 0 ? unreadNotifications : ""}
          >
            <img
              src={Notifications}
              alt="Notifications"
              onClick={() => {
                navigate("/notifications");
                markNotificationAsRead();
              }}
            />
          </Badge>
          <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}
            onClick={() => setToolTipOpen(false)}
          >
            <Tooltip
              open={toolTipOpen}
              onOpenChange={handleOpenChange}
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "10px",
                    gap: "8px",
                  }}
                >
                  <Avatar
                    style={{
                      backgroundColor: " #008fff",
                    }}
                  >
                    {qsetUserData.myapplication.applicationid.name.trim()[0]}
                  </Avatar>
                  <div>
                    <p style={{ marginBottom: "0px" }}>
                      {qsetUserData.myapplication?.applicationid?.name}
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                      {qsetUserData.myapplication?.applicationid?.email}
                    </p>
                  </div>
                </div>
              }
              placement="bottomRight"
              color="white"
              overlayInnerStyle={{
                color: "black",
                fontWeight: "bold",
              }}
            >
              <Avatar className="user-avatar">
                {qsetUserData.myapplication?.applicationid?.name.trim()[0]}
              </Avatar>
            </Tooltip>
          </Dropdown>
        </div>
      )}
    </nav>
  );
};

export default QSETHeader;
